import { useState, useEffect } from 'react';
import { FaPalette, FaPortrait, FaChalkboardTeacher, FaArrowRight } from 'react-icons/fa';
import { FiInstagram, FiFacebook, FiPhone, FiMessageSquare, FiMapPin } from 'react-icons/fi';
import { MdOutlineEvent } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import SEO from './components/SEO';

// Using your exact image paths
import logo from './assets/images.jpg';
import image2 from './assets/2.jpg';
import image3 from './assets/3.jpg';
import vint1 from './assets/vint1.jpg';
import banner2 from './assets/Banner2.jpg';
import banner from './assets/Banner.jpg';
import banner3 from './assets/Banner3.jpg';
import intA01 from './assets/exhibitions/intA01.jpg';
import intA02 from './assets/exhibitions/intA02.jpg';
import intA03 from './assets/exhibitions/intA03.jpg';
import intA04 from './assets/exhibitions/intA04.jpg';
import intA05 from './assets/exhibitions/intA05.jpg';
import intA06 from './assets/exhibitions/intA06.jpg';
import intA07 from './assets/exhibitions/intA07.jpg';
import intA08 from './assets/exhibitions/intA08.jpg';
import intA09 from './assets/exhibitions/intA09.jpg';
import intA10 from './assets/exhibitions/intA10.jpg';
import intA11 from './assets/exhibitions/intA11.jpg';
import intA12 from './assets/exhibitions/intA12.jpg';
import intA13 from './assets/exhibitions/intA13.jpg';
import intA14 from './assets/exhibitions/intA14.jpg';
import intB01 from './assets/exhibitions/intB01.jpg';
import intB02 from './assets/exhibitions/intB02.jpg';
import intB03 from './assets/exhibitions/intB03.jpg';
import intB04 from './assets/exhibitions/intB04.jpg';
import intB05 from './assets/exhibitions/intB05.jpg';
import intC01 from './assets/exhibitions/intc01.jpg';
import intC02 from './assets/exhibitions/intc02.jpg';
import intC03 from './assets/exhibitions/intc03.jpg';
import intC04 from './assets/exhibitions/intc04.jpg';
import intC05 from './assets/exhibitions/intc05.jpg';
import intC06 from './assets/exhibitions/intc06.jpg';
import intC07 from './assets/exhibitions/intc07.jpg';
import intC08 from './assets/exhibitions/intc08.jpg';
import intC09 from './assets/exhibitions/intc09.jpg';
import intC10 from './assets/exhibitions/intc10.jpg';
import intC11 from './assets/exhibitions/intc11.jpg';
import Navbar from './Navbar';
import Footer from './Footer';

const LandingPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  // Define galleryImages array using your imported images
  const galleryImages = [
    { id: 1, src: image2, alt: "Student artwork 1" },
    { id: 2, src: image3, alt: "Student artwork 2" },
    { id: 3, src: vint1, alt: "Student artwork 3" },
    { id: 4, src: image2, alt: "Student artwork 4" },
    { id: 5, src: image3, alt: "Student artwork 5" },
    { id: 6, src: intA01, alt: "Student artwork" },
    { id: 7, src: intA03, alt: "Student artwork" },
    { id: 8, src: intA04, alt: "Student artwork" },
    { id: 9, src: intA05, alt: "Student artwork" },
    { id: 10, src: intA06, alt: "Student artwork" },
    { id: 11, src: intA07, alt: "Student artwork" },
    { id: 12, src: intA08, alt: "Student artwork" },
    { id: 13, src: intA09, alt: "Student artwork" },
    { id: 14, src: intA10, alt: "Student artwork" },
    { id: 15, src: intA11, alt: "Student artwork" },
    { id: 16, src: intA12, alt: "Student artwork" },
    { id: 17, src: intA13, alt: "Student artwork" },
    { id: 18, src: intA12, alt: "Student artwork" },
    { id: 19, src: intB01, alt: "Student artwork" },
    { id: 20, src: intB02, alt: "Student artwork" },
    { id: 21, src: intB03, alt: "Student artwork" },
    { id: 22, src: intB04, alt: "Student artwork" },
    { id: 23, src: intB05, alt: "Student artwork" },
    { id: 24, src: intC01, alt: "Student artwork" },
    { id: 25, src: intC02, alt: "Student artwork" },
    { id: 26, src: intC03, alt: "Student artwork" },
    { id: 27, src: intC04, alt: "Student artwork" },
    { id: 28, src: intC05, alt: "Student artwork" },
    { id: 29, src: intC06, alt: "Student artwork" },
    { id: 30, src: intC07, alt: "Student artwork" },
    { id: 31, src: intC08, alt: "Student artwork" },
    { id: 32, src: intC09, alt: "Student artwork" },
    { id: 33, src: intC10, alt: "Student artwork" },
    { id: 34, src: intC11, alt: "Student artwork" },
    { id: 35, src: intA02, alt: "Student artwork" },

  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [galleryImages.length]);

  // Updated button styles with brand colors
  const primaryButtonClass = "bg-[#00B7F1] hover:bg-[#0095D1] text-white font-medium rounded px-6 py-3 transition-all duration-300 flex items-center gap-2 cursor-pointer";
  const secondaryButtonClass = "bg-[#C3D83B] hover:bg-[#A5C020] text-black font-medium rounded px-6 py-3 transition-all duration-300 flex items-center gap-2 cursor-pointer";
  const navButtonClass = "bg-[#00B7F1] hover:bg-[#0095D1] text-white font-medium rounded px-4 py-2 cursor-pointer";
  const navLinkClass = "text-gray-700 hover:text-[#00B7F1] transition font-light tracking-wide text-sm uppercase cursor-pointer";

  return (
    <>
      <SEO
        title="Welcome to Donzi Art Academy"
        description="Discover the world of art at Donzi Art Academy. We offer engaging art classes, workshops, and exhibitions for children. Join us to explore creativity and develop artistic skills in a nurturing environment."
        keywords="art academy, children's art classes, art workshops, art exhibitions, creative learning, art education, kids art programs, Donzi Art Academy, art for children"
      />
      <div className="min-h-screen w-full bg-white text-gray-800 font-sans overflow-x-hidden">
        <Navbar />

        {/* Hero Section */}
        <section className="pt-32 sm:pt-40 pb-12 sm:pb-16 px-4 bg-gradient-to-b from-[#00B7F1]/10 to-white relative z-0">
          <div className="container mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12">
              <div className="lg:w-1/2">
                <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-4 sm:mb-6 tracking-wide">
                  SHAPING THE <span className="font-normal" style={{ color: '#00B7F1' }}>FUTURE</span> <br /> OF <span className="font-normal" style={{ color: '#C3D83B' }}>VISUAL ARTS</span>
                </h1>
                <p className="text-lg sm:text-lg text-gray-600 mb-6 sm:mb-8 font-light tracking-wide">
                  Where Young Artists Grow.
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="bg-[#00B7F1] hover:bg-[#0095D1] text-white font-medium rounded px-8 py-4 text-lg transition-all duration-300 flex items-center gap-2 cursor-pointer" onClick={() => navigate('/register')}>
                    Register Now <FaArrowRight className="text-sm" />
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2 w-full">
                <div className="relative">
                  <div className="absolute -inset-2 sm:-inset-4 border-2 border-[#C3D83B] rounded-lg transform rotate-1 z-0"></div>
                  <img
                    src={banner3}
                    alt="Art students at Donzi Art Academy"
                    className="w-full h-auto object-cover rounded-lg relative z-10 shadow-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Programs Section */}
        <section id="programs" className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
          <div className="container mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-3xl sm:text-3xl md:text-4xl font-light mb-3 sm:mb-4 tracking-wide">OUR <span className="font-normal" style={{ color: '#00B7F1' }}>PROGRAMS</span></h2>
              <p className="text-lg sm:text-lg text-gray-600 max-w-2xl mx-auto font-light tracking-wide">
                Structured artistic development for all ages and skill levels
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {[
                {
                  title: "YOUNG ARTISTS",
                  description: "Foundational art education for children and teens, focusing on creativity and basic techniques.",
                  icon: <FaPalette className="text-3xl sm:text-3xl mb-4" style={{ color: '#00B7F1' }} />
                },
                {
                  title: "PORTFOLIO DEVELOPMENT",
                  description: "Comprehensive guidance for art school applications and competitions with personalized coaching.",
                  icon: <FaPortrait className="text-3xl sm:text-3xl mb-4" style={{ color: '#00B7F1' }} />
                },
                {
                  title: "ADULT CLASSES",
                  description: "Professional instruction for skill development, from beginners to advanced artists.",
                  icon: <FaChalkboardTeacher className="text-3xl sm:text-3xl mb-4" style={{ color: '#00B7F1' }} />
                }
              ].map((program, index) => (
                <div key={index} className="p-6 sm:p-8 hover:shadow-lg transition duration-300 border border-gray-100 rounded-lg hover:border-[#C3D83B]/30">
                  {program.icon}
                  <h3 className="text-xl sm:text-xl font-light tracking-wide mb-2 sm:mb-3 uppercase" style={{ color: '#00B7F1' }}>{program.title}</h3>
                  <p className="text-base sm:text-base text-gray-600 mb-4 sm:mb-5 font-light tracking-wide">{program.description}</p>
                  <div className="text-[#00B7F1] font-light tracking-wide flex items-center gap-2 hover:underline transition text-base uppercase cursor-pointer" onClick={() => navigate('/register')}>
                    Register <FaArrowRight className="text-sm" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Founder Section */}
        <section id="founder" className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
          <div className="container mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12">
              <div className="lg:w-1/2 order-2 lg:order-1">
                <h2 className="text-3xl sm:text-3xl md:text-4xl font-light mb-4 sm:mb-6 tracking-wide">
                  MEET <span className="font-normal" style={{ color: '#00B7F1' }}>DONZI EL HUSSEINY</span>
                </h2>
                <p className="text-lg sm:text-lg text-gray-600 mb-4 sm:mb-6 font-light tracking-wide">
                  Renowned artist and educator dedicated to cultivating artistic excellence in Egypt for over 15 years.
                </p>
                <div className="p-4 sm:p-6 mb-6 sm:mb-8 border-l-4 border-[#C3D83B] bg-[#00B7F1]/5 rounded-r-lg">
                  <p className="text-base sm:text-base text-gray-700 italic font-light tracking-wide">
                    "My mission is to help students discover their unique artistic voice while mastering fundamental techniques that stand the test of time."
                  </p>
                </div>
                <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                  <div className="flex items-center gap-3">
                    <svg className="w-5 h-5 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-base sm:text-base font-light tracking-wide">Oversees all curriculum development and teaching methodologies</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <svg className="w-5 h-5 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-base sm:text-base font-light tracking-wide">Personally teaches advanced masterclasses and portfolio development</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <svg className="w-5 h-5 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-base sm:text-base font-light tracking-wide">Exhibited internationally with works in private collections worldwide</span>
                  </div>
                </div>
                <div className="bg-[#00B7F1] hover:bg-[#0095D1] text-white font-medium rounded px-8 py-4 text-lg transition-all duration-300 flex items-center gap-2 cursor-pointer" onClick={() => navigate('/donzi')}>
                  VIEW ARTIST PORTFOLIO
                </div>
              </div>
              <div className="lg:w-1/2 order-1 lg:order-2 w-full">
                <div className="relative">
                  <div className="absolute -inset-2 sm:-inset-4 border-2 border-[#C3D83B] rounded-lg transform rotate-2 z-0"></div>
                  <img
                    src={banner2}
                    alt="Portrait of Donzi El Husseiny"
                    className="w-full h-auto object-cover rounded-lg relative z-10 shadow-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section id="gallery" className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
          <div className="container mx-auto">
            <div className="relative mb-8 sm:mb-10">
              <div className="flex overflow-hidden rounded-xl shadow-xl">
                <div
                  className="flex transition-transform duration-500 ease-in-out w-full"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {galleryImages.map((image) => (
                    <div key={image.id} className="w-full flex-shrink-0">
                      <div className="aspect-video overflow-hidden">
                        <img
                          src={image.src}
                          alt={image.alt}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation dots */}
              <div className="flex justify-center mt-4 sm:mt-6 space-x-2">
                {galleryImages.map((_, index) => (
                  <div
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${currentSlide === index ? 'bg-[#00B7F1] w-4 sm:w-6' : 'bg-gray-300'}`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-12 sm:py-16 px-4 sm:px-6 bg-gradient-to-b from-[#00B7F1]/10 to-white relative z-0">
          <div className="container mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-3xl sm:text-3xl md:text-4xl font-light mb-4 tracking-wide">Testimonials</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {[
                {
                  quote: "We do very much appreciate everything you do for our young talents, thank you so much for the great organisation and all the efforts behind it. It's a plus always to have our daughter under your care. As no one does it better.❤️❤️❤️",
                  author: "Parent"
                },
                {
                  quote: "Thank you, Mrs.Donzy, for the wonderful art exhibition! We truly appreciate the opportunity you gave Hassan to participate and showcase his work. It was such a special experience for him, and we're grateful for your support and encouragement.",
                  author: "Parent"
                },
                {
                  quote: "Donzi I would like to thank you for your great effort, support given to our kids. You are teaching them not only art but also ethics which is more important. you are delivering a message to them through your stories. My daughter's happiness now is YOU.",
                  author: "Parent"
                }
              ].map((testimonial, index) => (
                <div key={index} className="p-6 sm:p-8 bg-white rounded-lg shadow-sm border border-gray-100 relative z-10">
                  <p className="text-base sm:text-base text-gray-600 mb-4 sm:mb-5 font-light tracking-wide italic">"{testimonial.quote}"</p>
                  <p className="text-base sm:text-base text-gray-800 font-light tracking-wide">{testimonial.author}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 sm:py-16 px-4 sm:px-6 bg-[#00B7F1] text-white">
          <div className="container mx-auto text-center">
            <h2 className="text-3xl sm:text-3xl md:text-4xl font-light mb-4 sm:mb-6 tracking-wide">BEGIN YOUR <span className="font-normal" style={{ color: '#C3D83B' }}>ARTISTIC JOURNEY</span></h2>
            <p className="text-base sm:text-base text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto font-light tracking-wide">
              Join Donzi Art Academy today and discover your creative potential in our inspiring learning environment.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-[#C3D83B] hover:bg-[#A5C020] text-black font-medium rounded px-8 py-4 text-lg transition-all uppercase tracking-wide flex items-center gap-2 cursor-pointer" onClick={() => navigate('/register')}>
                ENROLL NOW <FaArrowRight className="text-sm" />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default LandingPage;